import React, { Component } from 'react'

class SectionType extends Component {
    getClass() {
        switch (this.props.sectionType) {
            case 'DEFAULT':
                return 'default'
            case 'WHITE':
                return 'white'    
            case 'SOFT_MAIN_COLOR':
                return 'soft-main-color'  
            case 'FULL_MAIN_COLOR':
                return 'full-main-color'
            case 'DARK':
                return 'dark'
            case 'THIN_DARK':
                return 'thin-dark'   
            case 'NO_PADDING':
                return 'no-padding'    
            default:
                return 'default'    
        }
    }

    render() {
        return (
            <section className={`section-type-${this.getClass()}`}>
                {this.props.children}
            </section>    
        )
    }
}

export { SectionType }


// WEBPACK FOOTER //
// ./src/components/sections/_SectionType.js